import {
  parseISO,
  parseJSON,
  parse,
  format,
  formatDistanceToNow
} from "date-fns";

export const dateParse = (
  dateString: string,
  formatString: string,
  options?: Record<string, any>
): Date | undefined => {
  if (!dateString) {
    return undefined;
  }
  return parse(dateString, formatString, new Date(), options);
};

export const dateParseISO = (
  dateString: string,
  options?: Record<string, any>
): Date | undefined => {
  if (!dateString) {
    return undefined;
  }
  return parseISO(dateString, options);
};

export const dateParseJSON = (
  date: string | number | Date
): Date | undefined => {
  if (!date) {
    return undefined;
  }
  return parseJSON(date);
};

export const dateFormat = (
  date: Date | number,
  formatString: string,
  options?: Record<string, any>
): string => {
  if (!date) {
    return "";
  }
  return format(date, formatString, options);
};

export const dateFormatDistanceToNow = (
  date: number | Date,
  options?: Record<string, any>
): string => {
  if (!date) {
    return "";
  }
  return formatDistanceToNow(date, options);
};
